import React, { useState } from "react";
import { Button, MenuItem } from "@mui/material";
import Menu from "@mui/material/Menu";
import MoreVertIcon from "@mui/icons-material/MoreVert";

export interface MoreActionButtonProps {
  saveDisabled?: boolean;
  onSaveChart: () => void;
  onDeleteChart: () => void;
}

export const MoreActionButton = ({
  saveDisabled = false,
  onSaveChart,
  onDeleteChart
}: MoreActionButtonProps): JSX.Element => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  return (
    <>
      <Button
        endIcon={<MoreVertIcon />}
        onClick={e => setAnchorEl(e.currentTarget)}
        color="secondary"
      >
        More Actions
      </Button>
      <Menu
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem
          onClick={() => {
            // close the menu
            setAnchorEl(null);
            onSaveChart();
          }}
          disabled={saveDisabled}
        >
          Save Chart
        </MenuItem>
        <MenuItem
          onClick={() => {
            // close the menu
            setAnchorEl(null);
            onDeleteChart();
          }}
        >
          Remove Chart
        </MenuItem>
      </Menu>
    </>
  );
};
